import React, { useMemo } from 'react'

import CommonNavbar from '@/components/layouts/common/Navbar'

import { useWindowWidth } from '@/hooks/common/useWindowWidth'
import { useActiveOrg } from '@/hooks/organization/useActiveOrg'
import { useActiveSbirId } from '@/hooks/sbir/useActiveSbirId'
import { useSbir } from '@/hooks/sbir/useSbir'

import type { Breadcrumb } from '@/types/navigation/Navbar'

const Navbar: React.FC = () => {
  const { activeSbirId } = useActiveSbirId()
  const { activeOrg } = useActiveOrg()
  const { data: sbir, isLoading } = useSbir(activeSbirId)

  const windowWidth = useWindowWidth()

  const breadcrumbs: Array<Breadcrumb> = useMemo(() => {
    const breadcrumbs = []
    if (activeOrg) {
      breadcrumbs.push({
        name: activeOrg.name,
        href: `/orgs/${activeOrg.id}/profile`,
      })
    }
    breadcrumbs.push({
      name: 'SBIR/STTR Opportunities',
      href: '/sbirs/search',
    })
    if (activeSbirId !== '') {
      breadcrumbs.push({
        name: sbir?.title ?? 'Opportunity',
        href: `/sbirs/${activeSbirId}`,
      })
    }
    return breadcrumbs
  }, [activeSbirId, activeOrg, sbir])

  if (activeSbirId === undefined) {
    return
  }

  return (
    <CommonNavbar
      isLoading={isLoading}
      breadcrumbs={
        (windowWidth || 0) > 1023
          ? breadcrumbs
          : [
              {
                name: 'SBIR/STTRs',
                href: '/sbirs/search',
              },
            ]
      }
    />
  )
}

export default Navbar
